import DEFAULT_VALUES_LAYER from '../default'

const { page: DEFAULT_PAGE_LAYER, ...rest } = DEFAULT_VALUES_LAYER

export default {
  ...rest,
  page: {
    ...DEFAULT_PAGE_LAYER,
    pageType: 'repescagem',
    pageName: '/webmotors/comprar/respescagem',
    pageNameTier2: 'respescagem',
  },
}
